import { render } from "./PositionDocumentCreate.vue?vue&type=template&id=5f513ba9"
import script from "./PositionDocumentCreate.vue?vue&type=script&lang=ts"
export * from "./PositionDocumentCreate.vue?vue&type=script&lang=ts"
script.render = render

export default script